// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ofj9P","content":"styles_content__IiNKw","title":"styles_title__FbMQ0","text":"styles_text__vFUpo","accept":"styles_accept__yirAq"};